// Specific Sport config (
import {sportConfig as builtSportConfig} from './dist/sport';
import {SportConfig} from './models/sport.model';

export const sportConfig: SportConfig = builtSportConfig;

